import script from "./OrderListing.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderListing.vue?vue&type=script&setup=true&lang=js"

import "./OrderListing.vue?vue&type=style&index=0&id=6ebac408&lang=css"

const __exports__ = script;

export default __exports__